import React from 'react';
import { PropTypes } from 'prop-types';

const CommentCircleIcon = ({ fill = '#000', width = '25' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 25 25" preserveAspectRatio="none">
        <g fill="none" fillRule="evenodd" stroke={fill} strokeWidth="1.6">
            <polygon points="7 8 18 8 18 15.062 13.52 15.057 9.997 18 9.997 15.057 7 15.057" />
            <circle cx="12.5" cy="12.5" r="11.7" />
        </g>
    </svg>
);

CommentCircleIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.number,
};

export default CommentCircleIcon;
